import React from 'react';
import Select from 'components/ui/Select';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const ActivityFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  activeFiltersCount 
}) => {
  const activityTypeOptions = [
    { value: 'all', label: 'All Activities' },
    { value: 'water-sports', label: 'Water Sports' },
    { value: 'wildlife', label: 'Wildlife & Nature' },
    { value: 'adventure', label: 'Adventure Sports' },
    { value: 'cultural', label: 'Cultural Experiences' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'easy', label: 'Easy' },
    { value: 'moderate', label: 'Moderate' },
    { value: 'challenging', label: 'Challenging' }
  ];

  const durationOptions = [
    { value: 'all', label: 'Any Duration' },
    { value: 'short', label: 'Under 2 hours' },
    { value: 'medium', label: '2-4 hours' },
    { value: 'long', label: '4+ hours' },
    { value: 'full-day', label: 'Full Day' }
  ];

  const priceRangeOptions = [
    { value: 'all', label: 'Any Price' },
    { value: 'budget', label: 'Under ₹1,000' },
    { value: 'mid', label: '₹1,000 - ₹2,500' },
    { value: 'premium', label: '₹2,500+' }
  ];

  const sortOptions = [
    { value: 'popularity', label: 'Most Popular' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'duration', label: 'Duration' },
    { value: 'difficulty', label: 'Difficulty Level' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-organic p-6 mb-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h2 className="text-lg font-heading font-semibold text-card-foreground">
            Filter Activities
          </h2>
          {activeFiltersCount > 0 && (
            <span className="px-2 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
              {activeFiltersCount}
            </span>
          )}
        </div>
        
        {activeFiltersCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All
          </Button>
        )}
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-4">
        {/* Activity Type */}
        <Select
          label="Activity Type"
          options={activityTypeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
          className="w-full"
        />

        {/* Difficulty Level */}
        <Select
          label="Difficulty"
          options={difficultyOptions}
          value={filters?.difficulty}
          onChange={(value) => onFilterChange('difficulty', value)}
          className="w-full"
        />

        {/* Duration */}
        <Select
          label="Duration"
          options={durationOptions}
          value={filters?.duration}
          onChange={(value) => onFilterChange('duration', value)}
          className="w-full"
        />

        {/* Price Range */}
        <Select
          label="Price Range"
          options={priceRangeOptions}
          value={filters?.priceRange}
          onChange={(value) => onFilterChange('priceRange', value)}
          className="w-full"
        />

        {/* Sort By */}
        <Select
          label="Sort By"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
          className="w-full"
        />
      </div>
      {/* Quick Filter Tags */}
      <div className="flex flex-wrap gap-2">
        <span className="text-sm text-muted-foreground">Quick filters:</span>
        {[
          { label: 'Family Friendly', key: 'familyFriendly' },
          { label: 'Available Today', key: 'availableToday' },
          { label: 'Seasonal Special', key: 'seasonal' },
          { label: 'Group Discounts', key: 'groupDiscount' }
        ]?.map((tag) => (
          <button
            key={tag?.key}
            onClick={() => onFilterChange(tag?.key, !filters?.[tag?.key])}
            className={`px-3 py-1 rounded-full text-xs font-medium transition-micro ${
              filters?.[tag?.key]
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            {tag?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ActivityFilters;